// Seçili koleksiyonlar URL'de tutulur: /pages/koleksiyonlar?koleksiyon=yuzuk,kolye
const SELECTED_PARAM = 'koleksiyon';

class CollectionsDirectory extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-collections-grid]');
    this.cards = Array.from(this.querySelectorAll('[data-collection-card]'));
    this.search = this.querySelector('[data-collections-search]');
    this.sort = this.querySelector('[data-collections-sort]');
    this.sortLabel = this.querySelector('[data-sort-label]');
    this.filter = this.querySelector('[data-collections-filter]');
    this.filterButton = this.querySelector('[data-filter-toggle]');
    this.viewButton = this.querySelector('[data-view-toggle]');
    this.empty = this.querySelector('[data-collections-empty]');

    this.picker = this.querySelector('[data-collections-picker]');
    this.pickerButton = this.querySelector('[data-picker-toggle]');
    this.pickerCount = this.querySelector('[data-picker-count]');
    this.pickerSearch = this.querySelector('[data-picker-search]');
    this.pickerList = this.querySelector('[data-picker-list]');
    this.pickerEmpty = this.querySelector('[data-picker-empty]');
    this.pickerOptions = Array.from(this.querySelectorAll('[data-picker-option]'));
    this.selectedList = this.querySelector('[data-selected-list]');

    this.sortPickerOptions();
    this.checkboxes = this.pickerOptions.map((option) => option.querySelector('[data-picker-checkbox]'));
    this.restoreSelection();

    this.search?.addEventListener('input', () => this.update());
    this.sort?.addEventListener('change', () => {
      this.syncSortLabel();
      this.update();
    });
    this.querySelectorAll('[data-product-filter]').forEach((input) => input.addEventListener('change', () => this.update()));
    this.viewButton?.addEventListener('click', () => this.toggleView());
    this.filterButton?.addEventListener('click', () => this.toggleFilter());

    this.pickerButton?.addEventListener('click', () => this.togglePicker());
    this.pickerSearch?.addEventListener('input', () => this.filterPickerOptions());
    this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => this.onSelectionChange()));
    this.querySelector('[data-picker-clear]')?.addEventListener('click', () => this.setSelection([]));
    this.querySelector('[data-picker-close]')?.addEventListener('click', () => this.closePicker(true));
    this.selectedList?.addEventListener('click', (event) => this.onSelectedListClick(event));

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (this.picker?.classList.contains('is-open')) this.closePicker(true);
      if (this.filter?.classList.contains('is-open')) {
        this.closeFilter();
        this.filterButton.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (this.filter && !this.filter.contains(event.target)) this.closeFilter();
      if (this.picker && !this.picker.contains(event.target)) this.closePicker();
    });

    this.syncSortLabel();
    this.filterPickerOptions();
    this.renderSelection();
    this.update();
  }

  get selectedHandles() {
    return this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
  }

  syncSortLabel() {
    // Geri tuşuyla dönüldüğünde tarayıcı select değerini geri yükleyebilir; etiket her zaman seçili seçeneği gösterir.
    if (this.sortLabel && this.sort) this.sortLabel.textContent = this.sort.selectedOptions[0]?.text || '';
  }

  toggleView() {
    const listView = this.classList.toggle('is-list');
    this.viewButton.setAttribute('aria-pressed', String(listView));
    this.viewButton.setAttribute('aria-label', listView ? 'Grid görünümüne geç' : 'Liste görünümüne geç');
  }

  toggleFilter() {
    const open = this.filter.classList.toggle('is-open');
    this.filterButton.setAttribute('aria-expanded', String(open));
    if (open) this.closePicker();
  }

  closeFilter() {
    this.filter?.classList.remove('is-open');
    this.filterButton?.setAttribute('aria-expanded', 'false');
  }

  togglePicker() {
    if (this.picker.classList.contains('is-open')) {
      this.closePicker();
      return;
    }
    this.closeFilter();
    this.picker.classList.add('is-open');
    this.pickerButton.setAttribute('aria-expanded', 'true');
    // Mobilde klavyenin kendiliğinden açılmaması için yalnızca geniş ekranda odaklanılır.
    if (window.matchMedia('(min-width: 750px)').matches) this.pickerSearch?.focus();
  }

  closePicker(returnFocus = false) {
    if (!this.picker?.classList.contains('is-open')) return;
    this.picker.classList.remove('is-open');
    this.pickerButton.setAttribute('aria-expanded', 'false');
    if (returnFocus) this.pickerButton.focus();
  }

  sortPickerOptions() {
    this.pickerOptions
      .sort((first, second) => first.dataset.collectionTitle.localeCompare(second.dataset.collectionTitle, 'tr'))
      .forEach((option) => this.pickerList.append(option));
  }

  filterPickerOptions() {
    const term = (this.pickerSearch?.value || '').trim().toLocaleLowerCase('tr');
    let visibleCount = 0;
    this.pickerOptions.forEach((option) => {
      option.hidden = Boolean(term) && !option.dataset.collectionTitle.toLocaleLowerCase('tr').includes(term);
      if (!option.hidden) visibleCount += 1;
    });
    if (this.pickerEmpty) this.pickerEmpty.hidden = visibleCount > 0;
  }

  restoreSelection() {
    const param = new URLSearchParams(window.location.search).get(SELECTED_PARAM);
    if (!param) return;
    const handles = new Set(param.split(','));
    this.checkboxes.forEach((checkbox) => {
      checkbox.checked = handles.has(checkbox.value);
    });
  }

  setSelection(handles) {
    const selected = new Set(handles);
    this.checkboxes.forEach((checkbox) => {
      checkbox.checked = selected.has(checkbox.value);
    });
    this.onSelectionChange();
  }

  onSelectionChange() {
    this.renderSelection();
    this.syncUrl();
    this.update();
  }

  onSelectedListClick(event) {
    const removeButton = event.target.closest('[data-selected-remove]');
    if (removeButton) {
      this.setSelection(this.selectedHandles.filter((handle) => handle !== removeButton.dataset.selectedRemove));
    } else if (event.target.closest('[data-selected-clear]')) {
      this.setSelection([]);
    } else {
      return;
    }
    // Tıklanan buton DOM'dan kalktığı için odak kaybolmasın.
    (this.selectedList.querySelector('button') || this.pickerButton)?.focus();
  }

  renderSelection() {
    const selected = this.checkboxes.filter((checkbox) => checkbox.checked);

    if (this.pickerCount) {
      this.pickerCount.textContent = String(selected.length);
      this.pickerCount.hidden = selected.length === 0;
    }
    this.pickerButton?.classList.toggle('is-active', selected.length > 0);

    if (!this.selectedList) return;
    this.selectedList.replaceChildren();
    this.selectedList.hidden = selected.length === 0;
    if (!selected.length) return;

    selected.forEach((checkbox) => {
      const title = checkbox.closest('[data-picker-option]').dataset.collectionTitle;
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'collections-directory__chip';
      chip.dataset.selectedRemove = checkbox.value;
      chip.setAttribute('aria-label', `${title} seçimini kaldır`);
      const chipTitle = document.createElement('span');
      chipTitle.textContent = title;
      chip.append(chipTitle);
      chip.insertAdjacentHTML(
        'beforeend',
        '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M15 5 5 15M5 5l10 10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
      );
      this.selectedList.append(chip);
    });

    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'collections-directory__chip-clear';
    clear.dataset.selectedClear = '';
    clear.textContent = 'Tümünü temizle';
    this.selectedList.append(clear);
  }

  syncUrl() {
    const url = new URL(window.location.href);
    const handles = this.selectedHandles;
    if (handles.length) url.searchParams.set(SELECTED_PARAM, handles.join(','));
    else url.searchParams.delete(SELECTED_PARAM);
    url.search = url.searchParams.toString().replace(/%2C/gi, ',');
    window.history.replaceState(window.history.state, '', url);
  }

  update() {
    const term = (this.search?.value || '').trim().toLocaleLowerCase('tr');
    const productFilter = this.querySelector('[data-product-filter]:checked')?.value || 'all';
    const selected = new Set(this.selectedHandles);
    const visibleCards = this.cards.filter((card) => {
      const title = card.dataset.collectionTitle.toLocaleLowerCase('tr');
      const count = Number(card.dataset.productsCount);
      // Seçim yoksa metafield listesindeki koleksiyonlar, seçim varsa yalnızca seçilenler gösterilir.
      const inScope = selected.size ? selected.has(card.dataset.collectionHandle) : card.hasAttribute('data-collection-listed');
      const matchesSearch = !term || title.includes(term);
      const matchesFilter = productFilter === 'all' || (productFilter === 'has-products' && count > 0);
      card.hidden = !(inScope && matchesSearch && matchesFilter);
      return !card.hidden;
    });

    this.sortCards(visibleCards);
    if (this.empty) this.empty.hidden = visibleCards.length > 0;
  }

  sortCards(cards) {
    const sortBy = this.sort?.value || 'metafield';
    const compare = (first, second) => {
      const title = first.dataset.collectionTitle.localeCompare(second.dataset.collectionTitle, 'tr');
      const products = Number(first.dataset.productsCount) - Number(second.dataset.productsCount);
      const position = Number(first.dataset.collectionPosition) - Number(second.dataset.collectionPosition);
      if (sortBy === 'alphabetical') return title;
      if (sortBy === 'alphabetical_reversed') return -title;
      if (sortBy === 'products_high') return -products || position;
      if (sortBy === 'products_low') return products || position;
      // Metafield sırası koleksiyonun yeni/eski tarih sırası olarak kullanılır.
      if (sortBy === 'date_reversed' || sortBy === 'metafield') return position;
      if (sortBy === 'date') return -position;
      return position;
    };
    cards.sort(compare).forEach((card) => this.grid.append(card));
  }
}

if (!customElements.get('collections-directory')) {
  customElements.define('collections-directory', CollectionsDirectory);
}
